<template>
  <v-data-table
    dense
    :headers="headers"
    :items="data"
    :calculate-widths="true"
  >
    <template v-slot:item.amount="{ item }">
      {{ item.amount | currency }}
    </template>
    <template v-slot:item.receivedAt="{ item }">
      {{ item.receivedAt | formatDate }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="mx-1 my-1 hide-on-print"
        color="primary"
        outlined
        @click.prevent="viewDirectPlacement($event, item)"
      >
        <v-icon color="primary">badge</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>

import { directPlacementEditRoute } from '@/lib/constants/routes'

export default {
  props: [
    'data'
  ],
  data () {
    return {
      headers: [
        { text: 'Client', value: 'clientName', width: '150px' },
        { text: 'Employee Name', value: 'employeeName', width: '150px' },
        { text: 'Amount', value: 'amount', width: '150px', align: 'center' },
        { text: 'Received On', value: 'receivedAt', width: '130px', align: 'center' },
        { text: 'Perm. Placement', value: 'actions', width: '130px', align: 'center', sortable: false }
      ]
    }
  },
  methods: {
    viewDirectPlacement (event, item) {
      const routeData = this.$router.resolve({ name: directPlacementEditRoute.name, params: { id: item.directPlacementId } })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
